import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { showValidateButton } from 'src/app/app-settings';
import { LoaderService } from 'src/shared/services';
import { ConfirmationDialogComponent } from 'src/shared/zoneiqui/components';
import { UploadFileDialogComponent } from '../upload-file-dialog/upload-file-dialog.component';

type ImportValidationState = {
    importValidationResult?: {
        isValid?: boolean;
    };
};

export abstract class ImportTableWorkflowBaseComponent<TValidationResult extends ImportValidationState> {
    selectedFileData: FormData = null;
    showValidateButton: boolean = showValidateButton;

    protected constructor(
        protected readonly loaderService: LoaderService,
        protected readonly dialog: MatDialog,
        protected readonly toastrService: ToastrService
    ) {}

    get canImport(): boolean {
        return !!this.getValidationData()?.importValidationResult?.isValid;
    }

    openDialog(): void {
        const uploadDialogRef = this.dialog.open(UploadFileDialogComponent, {
            width: '400px',
            height: '220px',
            data: {}
        });

        uploadDialogRef.afterClosed().subscribe(fileData => {
            if (!fileData) {
                return;
            }

            this.loaderService.show();
            this.selectedFileData = fileData;
            this.resetValidationData();
            this.validateSelectedFileData();
        });
    }

    importData(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '30%';
        dialogConfig.data = {
            title: 'Import data',
            topContent: this.getImportConfirmationMessage()
        };

        const importDialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        importDialogRef.afterClosed().subscribe(needToImport => {
            if (!needToImport) {
                return;
            }

            this.loaderService.show();
            this.runImportRequest().subscribe(
                () => {
                    this.toastrService.success('Import successfully completed', 'Success', {
                        closeButton: true
                    });
                    this.validateSelectedFileData();
                },
                err => {
                    console.error('Import error:', err);
                    this.loaderService.hide();
                    this.toastrService.error(this.getErrorMessage(err), 'Error', {
                        closeButton: true
                    });
                }
            );
        });
    }

    validateSelectedFileData(): void {
        this.runValidationRequest().subscribe(
            result => {
                this.setValidationData(result);
                this.loaderService.hide();
            },
            err => {
                console.error('Validation error:', err);
                this.loaderService.hide();
                this.toastrService.error(this.getErrorMessage(err), 'Error', {
                    closeButton: true
                });
            }
        );
    }

    validateZC(): void {
        const validationData = this.getValidationData() as any;
        if (validationData && typeof validationData.getValidationResults === 'function') {
            console.log(validationData.getValidationResults(false));
        }
    }

    protected getErrorMessage(err: any): string {
        return (err && err.error && err.error.messages ? err.error.messages : []).join('. ');
    }

    protected abstract getValidationData(): TValidationResult;
    protected abstract resetValidationData(): void;
    protected abstract setValidationData(result: TValidationResult): void;
    protected abstract getImportConfirmationMessage(): string;
    protected abstract runValidationRequest(): Observable<TValidationResult>;
    protected abstract runImportRequest(): Observable<any>;
}
